import { render } from "./manga-tag-box.vue?vue&type=template&id=9b3896c2&scoped=true&ts=true"
import script from "./manga-tag-box.vue?vue&type=script&lang=ts&setup=true"
export * from "./manga-tag-box.vue?vue&type=script&lang=ts&setup=true"

import "./manga-tag-box.vue?vue&type=style&index=0&id=9b3896c2&scoped=true&lang=less"

import exportComponent from "/home/runner/work/smanga/smanga/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9b3896c2"],['__file',"src/components/manga-tag-box.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "9b3896c2"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('9b3896c2', __exports__)) {
    console.log('reload')
    api.reload('9b3896c2', __exports__)
  }
  
  module.hot.accept("./manga-tag-box.vue?vue&type=template&id=9b3896c2&scoped=true&ts=true", () => {
    console.log('re-render')
    api.rerender('9b3896c2', render)
  })

}


export default __exports__